module.exports = __webpack_public_path__ + "1792395595471/fonts/fa-regular-400.8d9ab84.woff2";